import React, { useState, useEffect } from 'react';
import { Link } from 'gatsby';

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showManage, setShowManage] = useState(false);
  const [activeTab, setActiveTab] = useState('technical');
  const [analyticsAccepted, setAnalyticsAccepted] = useState(false);
  const [thirdPartyAccepted, setThirdPartyAccepted] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    const analyticsConsent = localStorage.getItem('analyticsAccepted') === 'true';
    const thirdPartyConsent = localStorage.getItem('thirdPartyAccepted') === 'true';
    setAnalyticsAccepted(analyticsConsent);
    setThirdPartyAccepted(thirdPartyConsent);

    if (!consent) {
      setTimeout(() => {
        setIsVisible(true);
      }, 3500);
    } else {
      if (analyticsConsent) {
        loadGoogleAnalytics(); // Solo se carga si el usuario ya aceptó
      }
    }
  }, []);

  // Cargar Google Analytics de manera asíncrona
  const loadGoogleAnalytics = () => {
    if (!window.dataLayer) {
      window.dataLayer = [];
    }
    function gtag() {
      window.dataLayer.push(arguments);
    }

    const script = document.createElement('script');
    script.async = true; // Esto hace que el script no bloquee el renderizado
    script.src = `https://www.googletagmanager.com/gtag/js?id=G-RQB8ZP3PFV`;
    script.onload = () => {
      gtag('js', new Date());
      // Configuración de Google Analytics (incluyendo linker para el seguimiento entre dominios)
      gtag('config', 'G-RQB8ZP3PFV', {
        linker: {
          domains: ['solucionesenlaweb.com', 'vascosolutions.com/zc/']  // Aquí agrega tus dominios
        }
      });
    };
    document.head.appendChild(script); // Cargar inmediatamente después de aceptar las cookies
  };

  const handleAcceptAll = () => {
    localStorage.setItem('cookieConsent', 'true');
    localStorage.setItem('analyticsAccepted', 'true');
    localStorage.setItem('thirdPartyAccepted', 'true');
    setCookieExpiration('true', 'analyticsAccepted');
    setCookieExpiration('true', 'thirdPartyAccepted');

    // Cargar Google Analytics de manera asincrónica solo después de la aceptación
    loadGoogleAnalytics();
    setIsVisible(false);
  };

  const handleRejectOptional = () => {
    localStorage.setItem('cookieConsent', 'true');
    localStorage.setItem('analyticsAccepted', 'false');
    localStorage.setItem('thirdPartyAccepted', 'false');
    setCookieExpiration('false', 'analyticsAccepted');
    setCookieExpiration('false', 'thirdPartyAccepted');
    setIsVisible(false);
  };

  const handleSaveSettings = () => {
    localStorage.setItem('analyticsAccepted', analyticsAccepted.toString());
    localStorage.setItem('thirdPartyAccepted', thirdPartyAccepted.toString());
    setCookieExpiration(analyticsAccepted, 'analyticsAccepted');
    setCookieExpiration(thirdPartyAccepted, 'thirdPartyAccepted');
    if (analyticsAccepted) loadGoogleAnalytics(); // Solo cargar si el usuario acepta
    setIsVisible(false);
  };

  const setCookieExpiration = (value, name) => {
    const expiryDate = new Date();
    expiryDate.setFullYear(expiryDate.getFullYear() + 1);
    document.cookie = `${name}=${value}; expires=${expiryDate.toUTCString()}; path=/`;
  };

  if (!isVisible) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: '0',
      width: '100%',
      backgroundColor: '#fff',
      fontFamily: 'Montserrat, sans-serif',
      color: '#333',
      textAlign: 'center',
      padding: '1rem',
      zIndex: 9999,
      display: 'flex',
      flexDirection: 'column',
      fontWeight: '400',
      fontSize: '12px',
      lineHeight: '18px',
      borderTop: 'solid 1px',
    }}>
      {!showManage ? (
        <>
          <p style={{ fontFamily: 'system-ui, sans-serif', fontSize: '14px', lineHeight: '20px' }}>
            Utilizamos tecnologías como las cookies para almacenar y/o acceder a la información del dispositivo con el fin de mejorar la experiencia de navegación y analizar el tráfico del sitio web. El consentimiento para estas tecnologías nos permitirá procesar datos como el comportamiento de navegación o los ID's únicos en este sitio. No consentir o retirar el consentimiento puede afectar negativamente ciertas características y funciones del sitio web. <strong>Este sitio no vende su información personal.</strong>
          </p>
          <p>
            <Link to="/politica-de-cookies" style={{ color: '#78c91c', paddingRight: '10px', textDecoration: 'underline', fontFamily: 'Montserrat, sans-serif', fontSize: '12px', lineHeight: '18px' }}>Política de Cookies</Link>
            <Link to="/politicas-de-privacidad/" style={{ color: '#78c91c', paddingRight: '10px', textDecoration: 'underline', fontFamily: 'Montserrat, sans-serif', fontSize: '12px', lineHeight: '18px' }}>Políticas de Privacidad</Link>
            <Link to="/aviso-legal" style={{ color: '#78c91c', paddingRight: '10px', textDecoration: 'underline', fontFamily: 'Montserrat, sans-serif', fontSize: '12px', lineHeight: '18px' }}>Aviso Legal</Link>
          </p>
          <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem' }}>
            <button
              onClick={() => setShowManage(true)}
              style={{
                padding: '0.5rem 1rem',
                backgroundColor: '#78c91c',
                color: 'white',
                border: 'none',
                cursor: 'pointer',
                fontWeight: '500',
                fontFamily: 'Montserrat, sans-serif',
                fontSize: '15px',
                lineHeight: '20px',
              }}
            >
              Gestionar
            </button>
            <button
              onClick={handleRejectOptional}
              style={{
                padding: '0.5rem 1rem',
                backgroundColor: '#dc3545',
                color: 'white',
                border: 'none',
                cursor: 'pointer',
                fontWeight: '500',
                fontFamily: 'Montserrat, sans-serif',
                fontSize: '15px',
                lineHeight: '20px',
              }}
            >
              Rechazar opcionales
            </button>
            <button
              onClick={handleAcceptAll}
              style={{
                padding: '0.5rem 1rem',
                backgroundColor: '#78c91c',
                color: 'white',
                border: 'none',
                cursor: 'pointer',
                fontWeight: '500',
                fontFamily: 'Montserrat, sans-serif',
                fontSize: '15px',
                lineHeight: '20px',
              }}
            >
              Aceptar todas
            </button>
          </div>
        </>
      ) : (
        <div style={{
          display: 'flex',
          flexDirection: 'row',
          '@media (max-width: 768px)': { flexDirection: 'column' },
        }}>
          <div style={{
            width: '100%',
            maxWidth: '300px',
            display: 'flex',
            flexDirection: 'column',
            textAlign: 'left',
            '@media (max-width: 768px)': { width: '100%' },
          }}>
            <button
              onClick={() => setActiveTab('technical')}
              style={{
                padding: '1rem',
                backgroundColor: activeTab === 'technical' ? '#fff' : '#444',
                color: activeTab === 'technical' ? '#333' : '#fff',
                border: 'none',
                cursor: 'pointer',
                textAlign: 'left',
                width: '100%',
                fontFamily: 'Montserrat, sans-serif',
                fontSize: '14px',
                lineHeight: '21px',
              }}
            >
              Cookies Funcionales
            </button>
            <button
              onClick={() => setActiveTab('analytics')}
              style={{
                padding: '1rem',
                backgroundColor: activeTab === 'analytics' ? '#fff' : '#444',
                color: activeTab === 'analytics' ? '#333' : '#fff',
                border: 'none',
                cursor: 'pointer',
                textAlign: 'left',
                width: '100%',
                fontFamily: 'Montserrat, sans-serif',
                fontSize: '14px',
                lineHeight: '21px',
              }}
            >
              Cookies Analíticas
            </button>
            <button
              onClick={() => setActiveTab('thirdParty')}
              style={{
                padding: '1rem',
                backgroundColor: activeTab === 'thirdParty' ? '#fff' : '#444',
                color: activeTab === 'thirdParty' ? '#333' : '#fff',
                border: 'none',
                cursor: 'pointer',
                textAlign: 'left',
                width: '100%',
                fontFamily: 'Montserrat, sans-serif',
                fontSize: '14px',
                lineHeight: '21px',
              }}
            >
              Cookies de Terceros
            </button>
            <button
              onClick={() => setActiveTab('doNotSell')}
              style={{
                padding: '1rem',
                backgroundColor: activeTab === 'doNotSell' ? '#fff' : '#444',
                color: activeTab === 'doNotSell' ? '#333' : '#fff',
                border: 'none',
                cursor: 'pointer',
                textAlign: 'left',
                width: '100%',
                fontFamily: 'Montserrat, sans-serif',
                fontSize: '14px',
                lineHeight: '21px',
              }}
            >
              No vender mi información
            </button>
          </div>
          <div style={{
            width: '100%',
            maxWidth: '600px',
            padding: '1rem',
            backgroundColor: '#fff',
            color: '#696969',
            fontWeight: '400',
            fontFamily: 'Montserrat, sans-serif',
            fontSize: '12px',
            lineHeight: '18px',
            '@media (max-width: 768px)': { width: '100%' },
          }}>
            {activeTab === 'technical' && (
              <div>
                <p>Las cookies técnicas son necesarias para el funcionamiento del sitio web y no se pueden desactivar.</p>
                <label style={{ display: 'block', marginBottom: '1rem' }}>
                  <input type="checkbox" checked disabled style={{ marginRight: '10px' }} />
                  Aceptar cookies técnicas
                </label>
              </div>
            )}
            {activeTab === 'analytics' && (
              <div>
                <p>Las cookies analíticas nos ayudan a mejorar nuestro sitio web mediante la recopilación de información anónima.</p>
                <label style={{ display: 'block', marginBottom: '1rem' }}>
                  <input
                    type="checkbox"
                    checked={analyticsAccepted}
                    onChange={(e) => setAnalyticsAccepted(e.target.checked)}
                    style={{ marginRight: '10px' }}
                  />
                  Aceptar cookies analíticas
                </label>
              </div>
            )}
            {activeTab === 'thirdParty' && (
              <div>
                <p>Las cookies de terceros se utilizan para integrar funcionalidades de terceros en el sitio, como botones de redes sociales o contenido embebido. Estas funcionalidades pueden recoger información sobre su navegación en el sitio y utilizar sus propias políticas de cookies.</p>
                <label style={{ display: 'block', marginBottom: '1rem' }}>
                  <input
                    type="checkbox"
                    checked={thirdPartyAccepted}
                    onChange={(e) => setThirdPartyAccepted(e.target.checked)}
                    style={{ marginRight: '10px' }}
                  />
                  Aceptar cookies de terceros
                </label>
              </div>
            )}
            {activeTab === 'doNotSell' && (
              <div>
                <p>No vendemos su información personal a terceros. Esta opción garantiza que su información no se compartirá con terceros para fines comerciales, de acuerdo con las leyes CPRA, CCPA y CalOPPA.</p>
              </div>
            )}
          </div>
        </div>
      )}
      {showManage && (
        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '1rem' }}>
          <button
            onClick={handleAcceptAll}
            style={{
              padding: '0.5rem 1rem',
              backgroundColor: '#78c91c',
              color: 'white',
              border: 'none',
              cursor: 'pointer',
              fontWeight: '500',
              fontFamily: 'Montserrat, sans-serif',
              fontSize: '14px',
              lineHeight: '21px',
            }}
          >
            Aceptar todas
          </button>
          <button
            onClick={handleSaveSettings}
            style={{
              padding: '0.5rem 1rem',
              backgroundColor: '#78c91c',
              color: 'white',
              border: 'none',
              cursor: 'pointer',
            }}
          >
            Guardar ajustes
          </button>
        </div>
      )}
    </div>
  );
};

export default CookieBanner;